export default __webpack_public_path__ + "static/media/O0005.c049e954.png";